import React from "react";
import _ from 'i18n';
import { Spin } from 'antd';
import { LoadingOutlined } from "@ant-design/icons";


const EventCardFeetching = (appType) => {
    const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
    return (
      <div className={'event-stats-app-type-card fetching text-center'}>
        <div className={'card-app-type-title'}>
          {appType == 'global' ? _('GLOBAL') :
            (appType == 'registering' ? _('registering') + 's' :
              (appType == 'cycle_registering' ? _('cycle_registering') + 's' :
                (appType == 'all_in' ? _('SEASONS') :
                  (appType == 'premium' ? 'Premium' : (appType == 'cycle_essential' ? "Cycle Essentiel" :  _('CONGRESS'))))))}
        </div>
        <div className={'flex justify-center'}>
          <Spin indicator={antIcon} />
        </div>
      </div>
    );
}

export default EventCardFeetching;







// WEBPACK FOOTER //
// ./app/components/feetching/EventCardFeetching.js